/**
 * i18n — English / Telugu for Daily Operations.
 *
 * The reusable engine lives in src/i18n (`createI18n`); this folder only supplies the
 * Daily Ops configuration: the languages, the UI strings (strings.en.js / strings.te.js)
 * and the curated item dictionary (terms.js). Components import everything from here:
 *   t(key, vars)  UI chrome, English fallback
 *   ln(name)      item names: curated terms → shared auto-translate cache → as typed
 * New, never-seen names are filled by translationEngine.js. The language is chosen per
 * DEVICE (localStorage) — the board runs on a shared kitchen iPad.
 */
import { createI18n } from '../../../i18n/createI18n';
import { LANG_LS_KEY } from '../config/constants';
import EN from './strings.en';
import TE from './strings.te';
import TERMS from './terms';

export const LANGS = [
  { id: 'en', label: 'EN', name: 'English' },
  { id: 'te', label: 'తె', name: 'తెలుగు' },
];
/** The language names are typed in (the engine's default: the first one) — never needs translating. */
export const SOURCE_LANG = LANGS[0].id;

const i18n = createI18n({
  languages: LANGS,
  resources: { en: EN, te: TE },
  terms: TERMS,
  termLangs: ['en', 'te'],   // TERMS pairs are [english, telugu]
  storageKey: LANG_LS_KEY,
});

export const LangProvider = i18n.LangProvider;
export const useLang = i18n.useLang;
export const useAutoTranslate = i18n.useAutoTranslate;
export const useEngine = i18n.useEngine;                 // used by translationEngine.js (Firestore)
export const localizeName = i18n.localize;               // (name, lang, cache?) → localized/as-typed
export const isKnownTerm = i18n.isKnownTerm;
export const normTerm = i18n.norm;
